import { useEffect } from "react";

import { useAbilitiesState } from "@/shared/stores/app-state";

export const useConnectPartyAbilities = (partyUUID: string | null) => {
	const { setPartyUUID, resetPartyUUID } = useAbilitiesState();

	useEffect(() => {
		setPartyUUID(partyUUID);

		return () => {
			resetPartyUUID();
		};
	}, [setPartyUUID, resetPartyUUID, partyUUID]);
};
